module.exports = __webpack_public_path__ + "static/media/previewlifestyle2-small.038c8edf.jpg";